// src/components/InvoiceList.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import "./invoice-form.css";

const API_BASE = process.env.REACT_APP_API_BASE || "https://dairy.server.statify.co.ke";

function InvoiceList() {
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    loadInvoices();
  }, []);

  async function loadInvoices() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/sales/`);
      if (!res.ok) throw new Error("Failed to fetch invoices");
      const list = await res.json();
      setInvoices(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error(err);
      alert("Unable to load invoices");
      setInvoices([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleDeleteInvoice(id) {
    if (!window.confirm("Delete this invoice?")) return;
    setDeletingId(id);
    try {
      const res = await fetch(`${API_BASE}/api/sales/${id}`, { method: "DELETE" });
      if (!res.ok) throw new Error("Delete failed");
      alert("Invoice deleted");
      loadInvoices();
    } catch (err) {
      console.error(err);
      alert("Failed to delete invoice");
    } finally {
      setDeletingId(null);
    }
  }

  function handleView(id) {
    navigate(`/invoice-form/view/${id}`);
  }

  function handleCreate() {
    navigate(`/invoice-form/new`);
  }

  function handleEdit(id) {
    // ✅ Navigate to edit page instead of opening modal
    navigate(`/invoice-form/edit/${id}`);
  }

  return (
    <div className="form-card">
      {/* Header */}
      <div className="form-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2>Sales Invoices</h2>
        <button className="btn btn-success" onClick={handleCreate}>
          + Create Invoice
        </button>
      </div>

      {/* Invoice Table */}
      <div className="invoice-list">
        {loading ? (
          <p>Loading invoices...</p>
        ) : (
          <table className="compact-table" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th>Invoice #</th>
                <th>Customer</th>
                <th>Total</th>
                <th>Status</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {invoices.length === 0 && (
                <tr>
                  <td colSpan={6} style={{ padding: 12, textAlign: "center" }}>
                    No invoices found.
                  </td>
                </tr>
              )}
              {invoices.map((inv) => (
                <tr key={inv.id}>
                  <td>{inv.invoice_number || "-"}</td>
                  <td>{inv.customer?.name || inv.buyer_name || "-"}</td>
                  <td>{Number(inv.total_amount || 0).toFixed(2)}</td>
                  <td>{inv.payment_status || "-"}</td>
                  <td>{inv.date ? new Date(inv.date).toLocaleString() : "-"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button className="btn-ghost small-btn" onClick={() => handleView(inv.id)}>
                        View
                      </button>
                      <button className="btn small-btn" onClick={() => handleEdit(inv.id)}>
                        Edit
                      </button>
                      <button
                        className="btn btn-danger small-btn"
                        onClick={() => handleDeleteInvoice(inv.id)}
                        disabled={deletingId === inv.id}
                      >
                        {deletingId === inv.id ? "Deleting..." : "Delete"}
                      </button>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default function InvoiceListWithLayout(props) {
  const { noLayout } = props || {};
  const content = <InvoiceList {...props} />;
  if (noLayout) return content;
  return <DashboardLayout>{content}</DashboardLayout>;
}
